import { createVerifiedFetch } from './index.js';
let impl;
export const verifiedFetch = async function verifiedFetch(resource, options) {
    if (impl == null) {
        impl = await createVerifiedFetch();
    }
    return impl(resource, options);
};
verifiedFetch.start = async function () {
    await impl?.start();
};
verifiedFetch.stop = async function () {
    await impl?.stop();
};
//# sourceMappingURL=singleton.js.map